import { create } from "zustand"

interface LayoutConfig {
  maxWidth?: string
  minWidth?: string
  fullWidth?: boolean
  leftAligned?: boolean
}

interface LayoutConfigStore {
  config: LayoutConfig
  setConfig: (config: LayoutConfig) => void
  resetConfig: () => void
}

const defaultConfig: LayoutConfig = {
  maxWidth: "1100px",
  minWidth: "600px",
  fullWidth: false,
  leftAligned: false
}

const useLayoutConfigStore = create<LayoutConfigStore>((set) => ({
  config: defaultConfig,
  setConfig: (config) => set({ config: { ...defaultConfig, ...config } }),
  resetConfig: () => set({ config: defaultConfig })
}))

export default useLayoutConfigStore 